var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRwa = function SvgRwa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    color: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19h-15c-.279 0-.418 0-.534.023a1.2 1.2 0 0 0-.943.943C3 20.082 3 20.22 3 20.5s0 .418.023.534a1.2 1.2 0 0 0 .943.943C4.082 22 4.22 22 4.5 22h15c.279 0 .418 0 .534-.023a1.2 1.2 0 0 0 .943-.943C21 20.918 21 20.78 21 20.5s0-.418-.023-.534a1.2 1.2 0 0 0-.943-.943C19.918 19 19.78 19 19.5 19m1.186-12.184-7.755-4.562a1.84 1.84 0 0 0-1.862 0L3.314 6.816A.636.636 0 0 0 3.636 8h16.728a.636.636 0 0 0 .322-1.184M18 11v8m-4-8v8m-4-8v8m-4-8v8"
  })));
};
export default SvgRwa;